import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { CommonService } from './commonService';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class BackOfficeService {
  private accessToken: any;
  public retailerData: any;
  public dropdownList: any;
  public lookupList: any;
  public identifiedTransactions = [];
  public unidentifiedTransactions = [];

  public totalTxnCount: any;
  public totalTxnAmount: any;
  public totalIdentifiedTxnCount: any;
  public totalIdentifiedTxnAmount: any;
  public totalUnidentifiedTxnCount: any;
  public totalUnidentifiedTxnAmount: any;

  public batchId: any;
  public companyName: any;
  public fileId: any;

  public constructor(_http: HttpClient, private commonService: CommonService) {
    this.accessToken = this.commonService.getAccessToken();
  }

  public setRetailerData(value) {
    this.retailerData = value;
  }

  public getRetailerData() {
    return this.retailerData;
  }
  public lookupsAndDropdowns(value, req) {
    if (req == 'drop') { this.dropdownList = value; }
    else if (req == 'lookup') { this.lookupList = value; }
  }
  public getlookupsAndDropdowns(req) {
    if (req == 'dropdown') { return this.dropdownList }
    else if (req == 'lookup') { return this.lookupList }
  }

  public setIdentifiedTransactions(trans) {
    this.identifiedTransactions = trans;
  }

  public getIdentifiedTransactions() {
    return this.identifiedTransactions;
  }

  public setUnidentifiedTransactions(trans) {
    this.unidentifiedTransactions = trans;
  }

  public getUnidentifiedTransactions() {
    return this.unidentifiedTransactions;
  }


  public setUnidentifiedTxnCount(txnCount) {
    this.totalUnidentifiedTxnCount = txnCount;
  }

  public getUnidentifiedTxnCount() {
    return this.totalUnidentifiedTxnCount;
  }

  public setUnidentifiedTxnAmount(txnAmount) {
    this.totalUnidentifiedTxnAmount = txnAmount;
  }

  public getUnidentifiedTxnAmount() {
    return this.totalUnidentifiedTxnAmount;
  }

  public settotalTxnCount(totalTxnCount) {
    this.totalTxnCount = totalTxnCount;
  }

  public gettotalTxnCount() {
    return this.totalTxnCount;
  }

  public settotalTxnAmount(totalTxnAmount) {
    this.totalTxnAmount = totalTxnAmount;
  }

  public gettotalTxnAmount() {
    return this.totalTxnAmount;
  }

  public setIdentifiedTxnCount(txnCount) {
    this.totalIdentifiedTxnCount = txnCount;
  }

  public getIdentifiedTxnCount() {
    return this.totalIdentifiedTxnCount;
  }

  public setIdentifiedTxnAmount(txnAmount) {
    this.totalIdentifiedTxnAmount = txnAmount;
  }

  public getIdentifiedTxnAmount() {
    return this.totalIdentifiedTxnAmount;
  }

  public setBatchId(id) {
    this.batchId = id;

  }

  public setCompanyName(companyName) {
    this.companyName = companyName;
  }

  public getBatchId() {
    return this.batchId;
  }

  public getCompanyName() {
    return this.companyName;
  }

  public setFileId(id) {
    this.fileId = id;

  }


  public getFileId() {
    return this.fileId;
  }

  public slpBatches(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-summary-retailer-adjustment?page=${page}&limit=50&isAll=${isAll}`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public retailersSearch(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/all-retailers?page=${page}&limit=50&isAll=${isAll}`;
    return this.commonService.regularPostRequest(url, body, headers);
  }
  public retailerDocument(body,page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-all-retailers-document-data?page=${page}&limit=50&isAll=${isAll}&altenar_retailer_id=${body.altenar_retailer_id}&altenar_sage_id=${body.altenar_sage_id}&business_name=${body.business_name}&charge_up_id=${body.charge_up_id}&email=${body.email}&igt_retailer=${body.igt_retailer}&nft_retailer_id=${body.nft_retailer_id}&owner_name=${body.owner_name}&retailer_id=${body.retailer_id}&supa_sellaz_id=${body.supa_sellaz_id}&mobile=${body.mobile}&documentType=${body.documentType}&uploaded_at=${body.uploaded_at}`;
    return this.commonService.regularGetRequest(url , headers);
  }

  public svlChartsData(body,page,isAll ) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-svl-chart-of-accounts-data?page=${page}&limit=50&isAll=${isAll}`;
    if (body.ACCTID) {
      url += `&ACCTID=${body.ACCTID}`;
    }
    if (body.ACCTGRPDES) {
      url += `&ACCTGRPDES=${body.ACCTGRPDES}`;
    }
    if (body.ACCTDESC) {
      url += `&dateTo=${body.ACCTDESC}`;
    }
    if (body.MAINACCOUNT) {
      url += `&MAINACCOUNT=${body.MAINACCOUNT}`;
    }
    return this.commonService.regularGetRequest(url , headers);
  }
  public ownersSearch(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-owner-details?page=${page}&limit=50&isAll=${isAll}`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public createChart(body,) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/create-svl-chart-of-accounts-data`;
    return this.commonService.regularPostRequest(url, body, headers);
  }
  public editDetails(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/edit-svl-chart-of-accounts-data`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public deleteDetails(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/delete-svl-chart-of-accounts-data`;
    return this.commonService.regularPostRequest(url, body, headers);
  }
  public addOwner(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/add-owner`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getTransactionHistoryById(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-retailer-wallet-histories-by-id?page=${page}&limit=100&isAll=${isAll}`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getPaymentsList(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/ria-get-in-progress-transactions?dateFrom=${body.dateFrom}&merchantType=${body.merchantType}&dateTo=${body.dateTo}&beneFirstName=${body.beneFirstName}&beneLastName=${body.beneLastName}&pin=${body.pin}&page=${page}&limit=100&isAll=${isAll}&status=${body.status}&transactionId=${body.transactionId}&transactionStatus=${body.transactionStatus}`;
    return this.commonService.regularGetRequest(url, headers);
  }


  public getRiaPaymentStatus(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/ria-get-status?orderId=${body.orderId}&merchantType=${body.merchantType}`;
    return this.commonService.regularGetRequest(url, headers);
  }

  public getUnidentifiedTransaction(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-unidentified-transactions?&page=${page}&limit=100&isAll=${isAll}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.companyName) {
      url += `&companyName=${body.companyName}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    return this.commonService.regularGetRequest(url, headers);
  }

  public getSlpAdjustment(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-retailer-adjustment?&page=${page}&limit=100&isAll=${isAll}`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public importSlpAdjustmentFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/process-adjustment-file`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public saveSlpAdjustmentFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/save-adjustment-file`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getSlpAdjustmentExport() {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/retailer-adjustment-export`;
    return this.commonService.regularGetRequest(url, headers);
  }

  public getIncompleteTransaction(batchId, transactionType, companyName, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-all-deposit-transactions-by-batchId?&batchId=${batchId}&transactionType=${transactionType}&companyName=${companyName}&page=${page}&limit=100&isAll=${isAll}`;
    return this.commonService.regularGetRequest(url, headers);
  }

  public createTransactionPaymentHistory(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/create-retailer-payment`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public createDepositTransactionPayment(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/create-temp-retailer-deposit-payment`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public sendDepositEmail(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = 'api/send-deposit-payment-email';

    return this.commonService.regularPostRequest(url, body, headers);
  }

  public rejectRiaPayment(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/reject-ria-transaction`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public approveRiaPayment(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/approve-ria-transaction`;
    return this.commonService.regularPostRequest(url, body, headers);
  }
  public viewRiaDetails(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    let url = `api/ria-get-data-by-id?orderId=${body.orderId}&merchantType=${body.merchantType}&deviceId=${body.deviceId}&clientType=${body.clientType}`;
    return this.commonService.regularGetRequest(url, headers);
  }
  public viewRiaAnalyticDetails(body,page,isAll):Observable<any>{
    const headers:HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    let url = `api/ria-get-analytic-data-by-multiple-ids?orderId=${body.orderId}&merchantType=${body.merchantType}&type=${body.type}&isAll=${isAll}&page=${page}`;
    if(body.limit){
      url+=`&limit=${body.limit}`
    }

    return this.commonService.regularGetRequest(url, headers);
  }

  public importFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/process-deposit-file`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public confirmImportFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/confirm-deposit-batch`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public confirmSaveBatch(batchId, companyName) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/save-deposit-batch?&batchId=${batchId}&companyName=${companyName}`;
    return this.commonService.regularGetRequest(url, headers);
  }


  public linkRemoveUnidentifiedTxns(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/process-unidentified-temp`;
    return this.commonService.regularPostRequest(url, body, headers);
  }


  public linkRemoveUnidentifiedGlobalTxns(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/unidentified-temp`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public invoiceSearch(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-invoices`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getRetailerDocument(fromDate, toDate, id, type, page): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/get-retailer-documents?&fromDate=${fromDate}&toDate=${toDate}&retailerId=${id}&type=${type}&page=${page}&limit=10`;
    return this.commonService.regularGetRequest(url, headers);
  }

  public uploadRetailerDocument(body) {
    const headers: HttpHeaders = new HttpHeaders({

      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/upload-retailer-document-web`;
    return this.commonService.regularPostRequest(url, body, headers).pipe(
      catchError(e => {
        if (document.getElementById('loader')) {
          document.getElementById('loader').style.display = 'none';
        }
        if (e.status == 413) {
          CommonService.apiErrorStatus = true;
        }
        if (e instanceof Response && window.location.hostname !== "localhost") {
          window.location.reload();
        } else {
          return throwError(new Error(`${e.status} ${e.statusText}`));
        }
      })
    );
  }

  public deleteRetailerDocument(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/delete-retailer-document-by-id`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public cancelRetailerDocument(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/cancel-retailer-requested-document`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public requestRetailerDocument(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/request-retailer-documents`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getDemographicsDetailsForReatilers(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public setDemographicsDetailsForReatilers(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/retailer-demographics`;
    return this.commonService.regularPutRequest(url, body, headers);
  }
  public setAddressDetailsForReatilers(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/retailer-address-details`;
    return this.commonService.regularPutRequest(url, body, headers);
  }

  public retailerSummary(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/get-retailer-by-id?version=1.1&retailer_id=` + id;
    return this.commonService.regularGetRequest(url, headers);
  }

  public getRetailerById(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/get-retailer-by-id?version=1.1&retailer_id=` + id;
    return this.commonService.regularGetRequest(url, headers);
  }

  public getOwnerById(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/get-owner-by-id?ownerId=` + id;
    return this.commonService.regularGetRequest(url, headers);
  }

  public getownerDetailsById(id): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/get-owner-locations-data?ownerId=` + id;
    return this.commonService.regularGetRequest(url, headers);
  }

  public getInvoiceById(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/get-invoice-by-id`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public sendInvoiceByEmail(body): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/send-invoice-to-email`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public setPersonDetailsForReatilers(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/retailer-person`;
    return this.commonService.regularPostRequest(url, body, headers);
  }
  public deletePersonDetailsForReatilers(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/delete-person-by-id`;
    return this.commonService.regularPutRequest(url, body, headers);
  }
  public deleteContactById(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/delete-person-contact-by-id`;
    return this.commonService.regularPutRequest(url, body, headers);
  }
  public updateIgtTerminalData(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/retailer-igt-terminal`;
    return this.commonService.regularPostRequest(url, body, headers);
  }
//insecure and secure 
  public getInsecureCustomers(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-ria-insecure-customers?page=${page}&limit=10&isAll=${isAll}`;
    if (body.firstName) {
      url += `&firstName=${body.firstName}`;
    }
    if (body.lastName) {
      url += `&lastName=${body.lastName}`;
    }
    if (body.trn) {
      url += `&trn=${body.trn}`;
    }
    return this.commonService.regularGetRequest(url, headers);
  }

  public importInsecureCustomersFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/process-ria-insecure-customers`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public confirmInsecureImportFile(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/confirm-ria-customers-file-data`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public deleteInsecureCustomers(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/delete-ria-insecure-customer`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public editInsecureCustomers(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/edit-ria-insecure-customer`;
    return this.commonService.regularPostRequest(url, body, headers);
  }
  public addInsecureCustomers(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/add-ria-insecure-customer`;
    return this.commonService.regularPostRequest(url, body, headers);
  }
  public getFundsHistory(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/retailers-transaction-history?page=${page}&limit=100&isAll=${isAll}`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getDepositHistory(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/retailers-deposit-history?page=${page}&limit=100&isAll=${isAll}`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public confirmUnidentifiedmodal(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/confirm-unidentified-deposit-batch`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public importFundsFileunidentified(body) {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/process-unidentified-transactions`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getSLpRevenueReportData(dateFrom, dateTo, merchantId): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    let url = `api/get-retailer-revenue-report?merchantId=${merchantId}`;
    if (dateFrom) {
      url += `&dateFrom=` + dateFrom;
    }
    if (dateTo) {
      url += `&dateTo=` + dateTo;
    }

    return this.commonService.regularGetRequest(url, headers);
  }

  public getSLpAgingReportData(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/get-aging-history-report?&page=${page}&isAll=${isAll}&limit=50`;

    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getproductsAgingReportData(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/get-date-product-aging-history?&page=${page}&isAll=${isAll}&limit=50`;

    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getdateAgingReportData(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/get-date-aging-history-report?&page=${page}&isAll=${isAll}&limit=100`;

    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getDepositBatchId(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-deposit-batches?&page=${page}&limit=50&isAll=${isAll}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.companyName) {
      url += `&companyName=${body.companyName}`;
    }
    if (body.batchId) {
      url += `&batchId=${body.batchId}`;
    }
    return this.commonService.regularGetRequest(url, headers);
  }


  public getmmgSummary(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-gy-mmg-files-summary-report?&page=${page}&limit=50&isAll=${isAll}`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.status) {
      url += `&status=${body.status}`;
    }
    return this.commonService.regularGetRequest(url, headers);
  }

  public getmmgReportById(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/get-gy-mmg-file-data?&page=${page}&limit=50&isAll=${isAll}`;
    if (body.fileId) {
      url += `&fileId=${body.fileId}`;
    }
    return this.commonService.regularGetRequest(url, headers);
  }
}

